import { useEffect, useState } from "react";
import api, { fmtMoney } from "@/lib/api";
import { PageHeader, Loader } from "@/components/ui-kit";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const CATS = [
  { key: "fournisseurs", label: "Fournisseurs" },
  { key: "ouvriers", label: "Ouvriers" },
  { key: "artisans", label: "Artisans" },
];

function Kpi({ label, value, tone = "slate" }) {
  const tones = { slate: "text-slate-700", emerald: "text-emerald-600", rose: "text-rose-600" };
  return (
    <div className="rounded-xl border bg-white p-4">
      <p className="text-[10px] uppercase font-mono text-slate-400">{label}</p>
      <p className={`font-mono font-bold text-lg ${tones[tone]}`}>{fmtMoney(value)}</p>
    </div>
  );
}

function CatTable({ cat }) {
  if (!cat) return null;
  return (
    <>
      <div className="grid grid-cols-3 gap-2 mb-3">
        <Kpi label="Total dû" value={cat.total} />
        <Kpi label="Payé" value={cat.paye} tone="emerald" />
        <Kpi label="Solde" value={cat.solde} tone="rose" />
      </div>
      <div className="rounded-xl border bg-white overflow-hidden"><div className="overflow-x-auto scrollbar-thin">
        <Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>Bénéficiaire</TableHead><TableHead>Pièces</TableHead><TableHead>Total</TableHead><TableHead>Payé</TableHead><TableHead>Solde</TableHead></TableRow></TableHeader>
          <TableBody>
            {(cat.rows || []).length === 0 ? <TableRow><TableCell colSpan={5} className="text-center text-slate-400 py-6">Aucune dette</TableCell></TableRow> : cat.rows.map((r) => (
              <TableRow key={r.nom} className="hover:bg-slate-50" data-testid={`dette-row-${r.nom}`}>
                <TableCell className="font-semibold">{r.nom}</TableCell>
                <TableCell className="text-sm text-slate-500">{r.nb}</TableCell>
                <TableCell className="font-mono text-xs">{fmtMoney(r.total)}</TableCell>
                <TableCell className="font-mono text-xs text-emerald-600">{fmtMoney(r.paye)}</TableCell>
                <TableCell className={`font-mono text-xs font-bold ${r.solde > 0 ? "text-rose-600" : "text-slate-400"}`}>{fmtMoney(r.solde)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div></div>
    </>
  );
}

export default function Dettes() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/payables").then((r) => setData(r.data)).catch(() => setData({ categories: {} })); }, []);
  if (!data) return <Loader />;
  const cats = data.categories || {};
  return (
    <div>
      <PageHeader title="Dettes" subtitle="Dettes envers fournisseurs, ouvriers et artisans" />
      <div className="mb-5"><Kpi label="Dette globale (solde)" value={data.solde_global} tone="rose" /></div>
      <Tabs defaultValue="fournisseurs">
        <TabsList>{CATS.map((c) => <TabsTrigger key={c.key} value={c.key} data-testid={`tab-dette-${c.key}`}>{c.label}{cats[c.key] ? ` · ${fmtMoney(cats[c.key].solde)}` : ""}</TabsTrigger>)}</TabsList>
        {CATS.map((c) => <TabsContent key={c.key} value={c.key}><CatTable cat={cats[c.key]} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
